/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelButton = new Class({
    Extends:QuriobotElement,
    template: function(){
        var base =  '<div class="panel--wrapper panel--button isLoading" family="{{ key }}" id="{{ eid }}">'+
                    '    <div class="panel--main">'+
                    '        <div class="panel--content">'+
                    '            <button type="button" class="large--button">'+
                    '                {% options %}'+
                    '            </button>'+
                    '        </div>'+
                    '        <div class="panel--overlay">'+
                    '            <div class="icon--checkWrapper fromRight circle">'+
                    '                <div class="check"></div>'+
                    '            </div>'+
                    '        </div>'+
                    '    </div>'+
                    '</div>';

        var option = '<div class="button--text">{{ text }}</div>';

        return {'base': base, 'option': option};
    },
    attach: function(){
        var Button = this.element.getElements('.large--button')[0];
        if (Button) {
            Button.addEvents({
                click: function(e){
                    this.element.addClass('isAnswered');
                    this.foldOutClose();
                    this.after(Button.getElements('.button--text')[0].get('text'));
                    Button.set('aria-hidden', true);
                }.bind(this)
            });
        }
    },
    after: function(content){
        var answerData = {
            'answer':{
                'value':'true',
                'content': content,
                'render':false,
            }
        }
        this.answerCallback(this.data, answerData);
    }
});
